import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconExperimentLine = ({ width = 24, height = 24, fill = '#1D2225', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.00001 20.6328C4.36217 20.6328 3.90884 20.3482 3.64001 19.779C3.37101 19.2097 3.43592 18.6802 3.83476 18.1905L9.50001 11.3058V5.13275H8.30776C8.09526 5.13275 7.91709 5.06083 7.77326 4.917C7.62959 4.77317 7.55776 4.595 7.55776 4.3825C7.55776 4.16983 7.62959 3.99175 7.77326 3.84825C7.91709 3.70458 8.09526 3.63275 8.30776 3.63275H15.6923C15.9048 3.63275 16.0829 3.70467 16.2268 3.8485C16.3704 3.99233 16.4423 4.1705 16.4423 4.383C16.4423 4.59567 16.3704 4.77375 16.2268 4.91725C16.0829 5.06092 15.9048 5.13275 15.6923 5.13275H14.5V11.3058L20.1653 18.1905C20.5641 18.6802 20.629 19.2097 20.36 19.779C20.0912 20.3482 19.6378 20.6328 19 20.6328H5.00001ZM7.00001 18.1328H17L13.6 14.1328H10.4L7.00001 18.1328ZM5.00001 19.1328H19L13 11.8328V5.13275H11V11.8328L5.00001 19.1328Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconExperimentLine;
